import { render, staticRenderFns } from "./order_center.vue?vue&type=template&id=f5e7c3f2&"
import script from "./order_center.vue?vue&type=script&lang=js&"
export * from "./order_center.vue?vue&type=script&lang=js&"
import style0 from "./order_center.vue?vue&type=style&index=0&id=f5e7c3f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports